import { useLayoutEffect } from 'react';

const SNAPSHOT_ID = 'server-seo-snapshot';
const HANDOFF_STATE_ATTRIBUTE = 'data-server-seo-state';
const HANDOFF_DURATION_MS = 220;

export const beginServerSeoSnapshotHandoff = ({
  documentRef = typeof document === 'undefined' ? null : document,
  windowRef = typeof window === 'undefined' ? null : window,
} = {}) => {
  const snapshot = documentRef?.getElementById(SNAPSHOT_ID);
  const documentElement = documentRef?.documentElement;
  if (!snapshot || !documentElement) return () => {};

  const finish = () => {
    documentElement.setAttribute(HANDOFF_STATE_ATTRIBUTE, 'complete');
    snapshot.hidden = true;
  };

  snapshot.setAttribute('aria-hidden', 'true');
  snapshot.setAttribute('inert', '');
  documentElement.setAttribute(HANDOFF_STATE_ATTRIBUTE, 'leaving');

  if (windowRef?.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    finish();
    return () => {};
  }

  const handleTransitionEnd = (event) => {
    if (event.target === snapshot && event.propertyName === 'opacity') finish();
  };
  snapshot.addEventListener('transitionend', handleTransitionEnd);
  const timeoutId = windowRef?.setTimeout?.(finish, HANDOFF_DURATION_MS);

  return () => {
    snapshot.removeEventListener('transitionend', handleTransitionEnd);
    if (timeoutId !== undefined) windowRef?.clearTimeout?.(timeoutId);
  };
};

const ServerSeoSnapshotHandoff = () => {
  useLayoutEffect(() => beginServerSeoSnapshotHandoff(), []);
  return null;
};

export default ServerSeoSnapshotHandoff;
